import { render, staticRenderFns } from "./EditAddMilestone.vue?vue&type=template&id=07e4f8e0&"
import script from "./EditAddMilestone.vue?vue&type=script&lang=ts&"
export * from "./EditAddMilestone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports